import Naluri from '~/common/api/naluri';
import {
  MODULES_TOGGLE_LOCK_MODULE_BEGIN,
  MODULES_TOGGLE_LOCK_MODULE_SUCCESS,
  MODULES_TOGGLE_LOCK_MODULE_FAILURE,
  MODULES_TOGGLE_LOCK_MODULE_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function toggleLockModule(userId, data) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: MODULES_TOGGLE_LOCK_MODULE_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      Naluri.put(`/api/expert/user_modules/${userId}`, data).then(
        (res) => {
          dispatch({
            type: MODULES_TOGGLE_LOCK_MODULE_SUCCESS,
            data
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: MODULES_TOGGLE_LOCK_MODULE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissToggleLockModuleError() {
  return {
    type: MODULES_TOGGLE_LOCK_MODULE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MODULES_TOGGLE_LOCK_MODULE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        toggleLockModulePending: true,
        toggleLockModuleError: null,
      };

    case MODULES_TOGGLE_LOCK_MODULE_SUCCESS:
      // The request is success
      const modules = state.modules.map(m => {
        if (m.slug === action.data.slug) {
          m.unlocked = action.data.enabled ? true : false;
        }
        return m;
      });

      return {
        ...state,
        modules: modules,
        toggleLockModulePending: false,
        toggleLockModuleError: null,
      };

    case MODULES_TOGGLE_LOCK_MODULE_FAILURE:
      // The request is failed
      return {
        ...state,
        toggleLockModulePending: false,
        toggleLockModuleError: action.data.error,
      };

    case MODULES_TOGGLE_LOCK_MODULE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        toggleLockModuleError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/modules/redux/toggleLockModule.js